// extracted by mini-css-extract-plugin
export default {"chipContainer":"Chip_chipContainer__+0eWq"};